module.exports = __webpack_public_path__ + "static/media/icBlockchain.0e75be68.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Press/images/icBlockchain.png
// module id = 883
// module chunks = 0